module.exports = function (e) {
  var t = {};
  function r(n) {
    if (t[n]) return t[n].exports;
    var u = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(u.exports, u, u.exports, r), u.l = !0, u.exports;
  }
  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var u in e) r.d(n, u, function (t) {
      return e[t];
    }.bind(null, u));
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(0),
    u = r.n(n);
  t.default = function (_ref) {
    let {
      start: e = 0,
      end: t = 60,
      delay: r = 1e3,
      repeat: o
    } = _ref;
    const [a, l] = Object(n.useState)(e);
    return Object(n.useEffect)(() => {
      const n = setInterval(() => {
        e < t && (a < t ? l(e => e + 1) : o ? (l(e), l(e => e + 1)) : (l(t), clearInterval(n))), e > t && (a > t ? l(e => e - 1) : o ? (l(e), l(e => e - 1)) : (l(t), clearInterval(n))), e === t && (l(t), clearInterval(n));
      }, r || 0);
      return () => clearInterval(n);
    }, [a]), u.a.createElement(u.a.Fragment, null, a);
  };
}]);